import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareMessenger({ url, handleSocialLinkClick }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'messenger')}
      style={{ color: grey600 }}
      data-testid="social-share-messenger"
    >
      <Icon name="share-messenger" size="lg" />
    </Link>
  );
}

SocialShareMessenger.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
};

export default SocialShareMessenger;
